export const inputCls = "w-full bg-white border border-slate-200 rounded-xl px-4 py-3 text-sm text-[#0f172a] placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-indigo-300";
export const selectCls = "w-full bg-white border border-slate-200 rounded-full px-3 py-2.5 text-xs font-medium text-[#0f172a] focus:outline-none focus:ring-2 focus:ring-indigo-400";
export const labelCls = "text-[11px] tracking-[0.2em] uppercase text-slate-400 font-semibold block mb-1.5";
export const STATUS_COLORS = {
  draft: "bg-amber-50 text-amber-600 border-amber-200",
  approved: "bg-indigo-50 text-indigo-600 border-indigo-200",
  published: "bg-emerald-50 text-emerald-600 border-emerald-200",
};
